import FoldersUpdateBatch from '@apps/truevail/admin/components/folders_update_batch'
import TagsUpdateBatch from '@apps/truevail/admin/components/tags_update_batch'
import LibraryAddBatch from '@apps/truevail/admin/components/library_add_batch'
import LibraryAdd from '@apps/truevail/admin/components/library_add'
import LibraryToken from '@apps/truevail/admin/tokens/library'
import Panel from '@admin/components/panel'
import Clone from './clone'
import React from 'react'
import New from './new'

const mapPropsToPanel = (props, context) => ({
  title: 't(Forms)',
  collection: {
    endpoint: '/api/admin/truevail/admin/forms',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Title)', key: 'title', primary: true },
      { label: 't(Library)', key: 'library_status', sort: 'status', collapsing: true, align: 'center', format: LibraryToken }
    ],
    defaultSort: { key: 'title', order: 'asc' },
    empty: {
      svg: 'square_check',
      title: 't(No Forms)',
      text: 't(You have not yet created any forms)',
      buttons: [
        { 
          label: 't(Create New Form)', 
          modal: New 
        }
      ]
    },
    entity: 'form',
    selectable: true,
    batch: {
      batch_type: 'truevail_forms',
      tasks: [
        { 
          label: 't(Add to Library)', 
          svg: 'book_plus',
          action: 'publish', 
          component: <LibraryAddBatch entity="admin" /> 
        },
        { 
          label: 't(Remove from Library)', 
          svg: 'book_minus',
          action: 'unpublish', 
          config: { entity: 'admin' } 
        },
        { 
          label: 't(Update Folders)',
          svg: 'folder',
          action: 'folder', 
          component: <FoldersUpdateBatch entity="admin" />  
        },
        { 
          label: 't(Update Tags)',
          svg: 'tags',
          action: 'tag', 
          component: <TagsUpdateBatch entity="admin" />  
        }
      ]
    },
    recordTasks: (record) => [
      {
        label: 't(Duplicate Form)',
        svg: 'copy',
        modal: <Clone form={ record } />
      },
      {
        label: 't(Add to Library)',
        svg: 'book_plus',
        show: record.status === 'draft',
        modal: <LibraryAdd scope="admin" entity="forms" record={ record } />
      },
      {
        label: 't(Remove from Library)',
        svg: 'book_minus',
        show: record.status === 'published',
        confirm: 't(Are you sure you want to unpublish this form?)',
        request: {
          endpoint: `/api/admin/truevail/admin/forms/${record.id}/unpublish`,
          method: 'PATCH',
          onSuccess: () => context.flash.set('success', 't(Sucessfully unpublished form)'),
          onFailure: () => context.flash.set('error', 't(Unable to unpublish form)')
        }
      },
      {
        label: 't(Delete Form)',
        svg: 'trash',
        confirm: 't(Are you sure you want to delete this form?)',
        deletable: true,
        request: {
          endpoint: `/api/admin/truevail/admin/forms/${record.id}`,
          method: 'DELETE',
          onSuccess: () => context.flash.set('success', 't(Successfully deleted form)'),
          onFailure: () => context.flash.set('error', 't(Unable to delete form)')
        }
      }
    ],
    onClick: (record) => context.router.push(`/admin/truevail/admin/forms/${record.id}`)
  },
  task: {
    svg: 'plus',
    modal: New
  }
})

export default Panel(null, mapPropsToPanel)
